export default import.meta.ROLLDOWN_FILE_URL_JtileLNDKFe7yXHDq9n25A